<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-img"><img alt="image" src="images/img24.jpg"/></p>
<p class="chap"><a id="ch11"></a>JOHN SMITH, 1610</p>
<p class="noindent"><span class="big">P</span>erhaps no early leader was more instrumental in saving and bringing prosperity to the Jamestown colony than mercenary, adventurer, explorer, and mapmaker Captain John Smith. The early years were marked by disease, hunger, attacks from Native Americans, and serious divisions within the leadership. By 1608, Smith was the president of the colony.</p>
<p class="indent">First, he got the local Powhatan tribes to trade for food the colony desperately needed. Then, he tightened the defenses of the colony and forced colonists to work if they wanted to eat. His leadership style aroused resentment in the colony, and by the summer of 1609 rumors of an assassination plot were rampant in Jamestown. At about that time, he was terribly burned in a gunpowder accident and had to return to England for medical care. Smith never returned to the Chesapeake area. Although he could inspire people, he also infuriated them. Nevertheless, under his leadership the colony survived, and his maps of the Chesapeake Bay proved an excellent resource for the colony in the decades ahead. <span class="color">(12-053, 12-054)</span></p>
<p class="image"><img alt="image" src="images/img25.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter011.vue?bedc5cc0